module.exports = __webpack_public_path__ + "fonts/ttnorms-regular-webfont.6ee202d1.woff";